import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { COMPANY_COSTUMER_TYPE, COSTUMER_TYPES, INDIVIDUAL_COSTUMER_TYPE } from "../model";
import { ReactNode } from "react";

interface CostumerTypesSelectProps {
  isCompany: boolean;
  handleTypeChange: (
    event: SelectChangeEvent<string>,
    child: ReactNode
  ) => void;
}

export const CostumerTypesSelect: React.FC<CostumerTypesSelectProps> = (
  props
) => {
  const { isCompany, handleTypeChange } = props;

  return (
    <FormControl fullWidth>
      <InputLabel id="costumer-type-select-label">Tipo</InputLabel>
      <Select
        labelId="costumer-type-select-label"
        id="costumer-type-select"
        value={mapTypeToLabel(isCompany).value}
        label="Tipo"
        onChange={handleTypeChange}
      >
        {COSTUMER_TYPES.map((type) => (
          <MenuItem value={type.value} key={`menu-item-${type.value}`}>
            &nbsp;{type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

function mapTypeToLabel(isCompany: boolean) {
  const type = isCompany ? COSTUMER_TYPES.find((t) => t.value === COMPANY_COSTUMER_TYPE) : COSTUMER_TYPES.find((t) => t.value === INDIVIDUAL_COSTUMER_TYPE);
  return type ? type : COSTUMER_TYPES[0];
}
